import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Flame, Gift, X } from "lucide-react";

const KEY = "be_comeback_dismissed";

/**
 * Comeback banner — shows when:
 * - user has at least one practice attempt before
 * - last_practice_date was more than 3 days ago
 * Dismiss persists for the day.
 */
export default function ComebackBanner({ user, attempts = [] }) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!user) return;
    const lastDay = user.last_practice_date;
    if (!lastDay || attempts.length === 0) return;
    const daysGap = Math.floor((Date.now() - new Date(lastDay).getTime()) / 86400000);
    if (daysGap < 3) return;
    if (localStorage.getItem(KEY) === new Date().toDateString()) return;
    setOpen(true);
  }, [user, attempts]);

  if (!open) return null;

  const dismiss = () => {
    localStorage.setItem(KEY, new Date().toDateString());
    setOpen(false);
  };

  return (
    <div className="relative mb-6 rounded-xl border border-[color:var(--brand-amber)]/40 bg-[color:var(--brand-amber-soft)]/40 p-5 flex items-center gap-4" data-testid="comeback-banner">
      <div className="flex h-10 w-10 items-center justify-center rounded-md bg-[color:var(--brand-amber)] text-white">
        <Flame className="h-5 w-5 flame-anim" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="font-display text-base">We saved your streak — pick up where you left off</div>
        <p className="text-sm text-muted-foreground">Practice 10 questions today and earn a <b className="text-foreground inline-flex items-center gap-1"><Gift className="h-3.5 w-3.5" /> Comeback +50 XP</b> bonus.</p>
      </div>
      <Link to="/marketplace">
        <button className="btn-primary h-9 px-4 text-xs" data-testid="comeback-cta">Resume practice</button>
      </Link>
      <button onClick={dismiss} className="rounded-md p-1.5 hover:bg-accent" aria-label="Dismiss"><X className="h-4 w-4" /></button>
    </div>
  );
}
